// extracted by mini-css-extract-plugin
module.exports = {"container":"Crossbox_container__3C0nN","checkbox":"Crossbox_checkbox__3Psvq","icon":"Crossbox_icon__N4B9b","row":"Crossbox_row__3ByNa","label":"Crossbox_label__1YtQZ"};